import { Button, Grid } from "@mui/material";
import logo from "../../../medias/discord.png";
import { styles } from "../../../theme/styles";

export const DiscordButton = () => {
  return (
    <Grid
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 0,
      }}
      item
      xs={12}
    >
      <Button
        href="https://discord.com/oauth2/authorize?client_id=1228089697088311298&response_type=code&redirect_uri=https%3A%2F%2Fwww.opclub.gg%2FgetDiscordToken&scope=email+identify"
        target="_blank"
        style={styles.discordButton}
        onMouseEnter={(e) => (e.currentTarget.style.borderColor = "white")}
        onMouseLeave={(e) =>
          (e.currentTarget.style.borderColor = "transparent")
        }
        /*onClick={() => navigate("/games")*/
      >
        <img src={logo} style={styles.discordImage} alt="Try in Discord" />
        <span style={styles.discordText}>Teste no Discord</span>
      </Button>
    </Grid>
  );
};
